/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description constants for utils
 */

export const TILE_SIZE = 512
export const ZOOM_MAX = 21

// constants from NZR

export const ZOOM_MIN_MOBILE = 1

export const ZOOM_MIN = 2

export const ZOOM_COUNTRY = 2

export const ZOOM_STATE = 6

// min zoom that still shows clusters
export const ZOOM_CITY_MIN = 9

// default for city
export const ZOOM_CITY = 11

// default for unknown
export const ZOOM_DEFAULT = ZOOM_CITY

// default for hood
export const ZOOM_HOOD = 14

export const ZOOM_STREET = 13

export const ZOOM_ADDRESS = 15

export const MAX_LAT_DELTA = 2

export const MAX_LNG_DELTA = 2

export const NO_MARKER_ERROR_MESSAGE = 'No listings that match your search.'

export const UNSUPPORTED_BROWSER_GEOLOCATION = 'This browser does not support geolocation'

export const PLEASE_ALLOW_GEOLOCATION = 'Please allow geolocation access'

export const DEFAULT_MAP_LOCATION = {
  box: {
    maxLat: 37.8333031030963,
    maxLng: -122.35698,
    minLat: 37.70648,
    minLng: -122.51464,
  },
  lat: 37.7749,
  lng: -122.4194,
  cityName: 'San Francisco',
  country: 'USA',
  stateName: 'CA',
  url: 'san-francisco-ca',
  zoom: ZOOM_CITY,
}

export const DEFAULT_FALLBACK_BOX_DISTANCE = 5

export const CITY_FALLBACK_BOX_DISTANCE = 5

export const HOOD_FALLBACK_BOX_DISTANCE = 1

export const STREET_FALLBACK_BOX_DISTANCE = 0.25

export const CUSTOM_MAP_STYLE = [
  {
    featureType: 'administrative',
    stylers: [{ saturation: -30 }, { lightness: 20 }],
  },
  {
    featureType: 'landscape.man_made',
    stylers: [{ saturation: -15 }, { lightness: 35 }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{ color: '#dbdee1' }, { saturation: -65 }, { lightness: 25 }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [{ color: '#e3edef' }, { saturation: -65 }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [{ color: '#c7f5c6' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.business',
    stylers: [{ color: '#c7f5c6' }, { visibility: 'off' }],
  },
  {
    featureType: 'poi.medical',
    elementType: 'geometry',
    stylers: [{ color: '#c7f5c6' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#c7f5c6' }],
  },
  {
    featureType: 'poi.school',
    elementType: 'geometry',
    stylers: [{ color: '#c7f5c6' }],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'geometry',
    stylers: [{ color: '#c7f5c6' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{ lightness: 35 }],
  },
  { featureType: 'road.highway', stylers: [{ lightness: 20 }] },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{ color: '#86ccff' }, { lightness: 50 }],
  },
]

export const STREET_VIEW_DEFAULT_OPTIONS = {
  scrollwheel: false,
}

export const HEADER_HEIGHT = 64
export const HEADER_MOBILE_HEIGHT = 100
export const RAIL_WIDTH = 605
export const BREAKPOINT_MOBILE = 770
